import type { FaireProductEntity } from "../../entity_types/product";

export const p_93tgcbezxs: FaireProductEntity = {
  token: "p_93tgcbezxs",
  type: "product",
  name: "Tallow",
  brandToken: "b_c96vrxm17w",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/415695f37ed0528d7bb39612a30ff579cd353848142532df11d84101ee6cc8fc.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/fd547db6d079c89e9f148b11895d256ac40b47a3d168042bbd0795341d17efdb.jpeg",
    "https://cdn.faire.com/fastly/ee18d818674c5ecd5d62f26bd759ddbe694be9c48af91946fcb5b08548552425.jpeg",
  ],
  priceDollars: 24.94,
  description:
    "\nTallow provides deep hydration, supports elasticity, and strengthens your skin barrier. Tallow is full of fatty acids and vitamins that are beneficial for skin rejuvenation. Oils Inside are known to fight acne, fight off bacteria, reduce inflammation and provide relaxation.\n\n**Now in amber",
  tags: [],
  msrpDollars: 49.88,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:24:59.590Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
